module.exports = __webpack_public_path__ + "img/big-report-bg.e624160b.png";